import React, {Component, useState} from 'react';
// import './style.scss'
const ChaplaincyCertificates = (props) => {
    const chaplaincy_certificate_data = props?.chaplaincyCertificateData.length ? props?.chaplaincyCertificateData[0] : null;
    // console.log(chaplaincy_certificate_data?.chap_certificate_body);

    return ( 
        <div>
        <div className='chaplaincy_certificate-lcontainer'>
            <h1>{chaplaincy_certificate_data?.chap_certificate_header?.page_title}</h1>
            {chaplaincy_certificate_data?.chap_certificate_body.map((data,index)=>(
                <>
                <h1>{data.heading??''}</h1>
                <div dangerouslySetInnerHTML={{__html:data.content ?? ''}}></div>
                </>)
            )}
        </div>
        </div>
     );
}
 
export default ChaplaincyCertificates;
